import { dialog } from "nq-component";
import BaseFormPresenter from "../../../../../base/BaseFormPresenter";
import DialogModal from "../../../../../components/Dialog";
import { findObjectUseCase } from "../../../../../usecases/object";
import { auditLogUseCase } from "../../../../../usecases/logs";

class InventoryFormPresenter extends BaseFormPresenter {
  componentDidMount() {
    this.init();
    this.getObject();
    this.fetchInfiniteItems();
  }

  onChange(value, field) {
    this.change[field] = value;
    this.object[field] = value;

    // Preserve raw_materials if present in the view
    if (!this.object.raw_materials && this.view.state.object?.raw_materials) {
      this.object.raw_materials = [...this.view.state.object.raw_materials];
    }

    this.view.setObject(this.object);
  }

  async getObject() {
    const collection = this.view.getCollectionName();
    const id = this.object.id || this.view.getObjectId();
    if (id) {
      const params = { include: ["raw_materials", "raw_materials.uom", "uom"] };
      try {
        this.view.showProgress();
        this.object = await this.getObjectUseCase.execute(collection, id, {
          params,
        });
        this.view.hideProgress();
        this.view.setObject(this.object);
      } catch (error) {
        this.view.hideProgress();
        this.view.showError(error);
      }
    }
  }

  async fetchInfiniteItems(isInitial = false, keyword = "") {
    this.view.setState({ isLoading: true });

    if (isInitial) {
      this.view.setState({
        skip: 0,
        infiniteItems: [],
        hasMore: true,
      });
    }

    const skip = isInitial ? 0 : this.view.state.skip;

    const items = await findObjectUseCase().execute("raw_materials", {
      where: {
        itemName: { $regex: keyword || "", $options: "i" },
      },
      limit: 10,
      include: ["uom"],
      skip,
    });

    this.view.setState((prev) => ({
      infiniteItems: isInitial ? items : [...prev.infiniteItems, ...items],
      skip: skip + items.length,
      hasMore: items.length === 10,
      isLoading: false,
    }));
  }

  handleInfiniteScroll = (e) => {
    const { scrollTop, clientHeight, scrollHeight } = e.target;
    const { hasMore, isLoading } = this.view.state;

    if (
      scrollHeight - scrollTop <= clientHeight + 10 &&
      hasMore &&
      !isLoading
    ) {
      this.fetchInfiniteItems();
    }
  };

  // async save() {
  //   this.view.showProgressDialog();
  //   const collection = this.view.getCollectionName();
  //   const user = this.view.getCurrentUser();
  //   const adjustmentType = this.view.getAdjustmentType();
  //   const now = new Date().toISOString();

  //   const editedItems = this.view.state.selectedQuantities || {};
  //   const infiniteItems = this.view.state.infiniteItems || [];

  //   try {
  //     for (const id in editedItems) {
  //       const edited = editedItems[id];
  //       const found = infiniteItems.find((item) => item.id === id);
  //       const quantity = parseFloat(edited.quantity || "0");
  //       const itemName = edited.itemName || found?.itemName;

  //       // 1. Fetch existing inventory data for this item from the DB
  //       const [existing] = await findObjectUseCase().execute("inventory", {
  //         where: {
  //           itemName: { $eq: itemName },
  //           "storeId.id": { $eq: user?.storeAnalytic?.[0]?.id },
  //         },
  //         limit: 1,
  //       });

  //       const currentCount = parseFloat(existing?.systemCount || "0"); // from DB
  //       let systemCount = quantity;
  //       let actualCount = null;

  //       // 2. Adjustment logic
  //       switch (adjustmentType) {
  //         case "Manual Add":
  //           systemCount = currentCount + quantity;
  //           break;
  //         case "Manual Deduct":
  //           systemCount = currentCount - quantity;
  //           break;
  //         case "Actual Count":
  //           actualCount = quantity;
  //           break;
  //         case "Beginning Inventory":

  //         default:
  //           systemCount = quantity;
  //           break;
  //       }

  //       // 3. Prepare payload
  //       const payload = {
  //         id: existing?.id, // retain ID for upsert
  //         itemName: edited.itemName || existing?.itemName,
  //         systemCount: systemCount.toString(),
  //         actualCount:
  //           adjustmentType === "Actual Count" ? quantity.toString() : undefined,
  //         uom: found?.uom || {},
  //         lastAdjusted: now,
  //         adjustedBy: { id: user.id },
  //         // adjustmentType,
  //         acl: this.view.getAcl(),
  //       };

  //       payload.storeId = { id: user.storeAnalytic[0]?.id };

  //       const result = await this.upsertUseCase.execute(collection, payload);

  //       //  Create log entry
  //       const logEntry = {
  //         user: { id: user.id },
  //         itemName: payload.itemName,
  //         adjustmentType,
  //         oldQuantity: currentCount.toString(),
  //         newQuantity: systemCount.toString(),
  //       };

  //       logEntry.storeId = { id: user.storeAnalytic[0]?.id };

  //       await this.upsertUseCase.execute("inventory_logs", logEntry);

  //       await auditLogUseCase().create({
  //         user: { id: user.id },
  //         logDate: new Date().toISOString(),
  //         message: `${adjustmentType}: ${
  //           result.itemName
  //         } from ${currentCount.toString()} to ${systemCount.toString()}`,
  //         collection,
  //         objectId: result.id,
  //         payload: {
  //           before: existing || null,
  //           after: result,
  //         },
  //         store: { id: user.storeAnalytic[0]?.id },
  //       });

  //       // After your existing upsert + logs:
  //       const day = new Date().toISOString().slice(0, 10); // 'YYYY-MM-DD'
  //       const storeId = user.storeAnalytic[0]?.id;
  //       const key = `${storeId}|${
  //         result.id || existing?.id || itemName
  //       }|${day}`;

  //       await this.upsertUseCase.execute("fc_variant", {
  //         variantId: key, // maps to _id in Mongo adapter; else build _id server side
  //         storeId: { id: storeId, code: user.storeAnalytic[0]?.code },
  //         item: {
  //           id: result.id || existing?.id || itemName,
  //           name: result.itemName,
  //           uom: found?.uom?.name || found?.uom || "",
  //         },
  //         variantDate: day,

  //         fcProduct: edited.itemName || existing?.itemName,
  //         beginningInventory: systemCount.toString(), //beginning
  //         salesCount: "", // ilan ang nabenta in that day
  //         ending: systemCount.toString(), // Keep “ending” always aligned with inventory.systemCount
  //         pCount:
  //           adjustmentType === "Actual Count" ? quantity.toString() : undefined, //actual count or physical count
  //         costOfGoods: "", // cost * sales count
  //         ideal: "", // ending inventory - pCount (actual count)
  //         variant: "", // (ending - physical count) - sales count

  //         // Capture movements inferred from the adjustment type
  //         movements: {
  //           manualAdd:
  //             adjustmentType === "Manual Add" ? Number(edited.quantity) : 0,
  //           manualDeduct:
  //             adjustmentType === "Manual Deduct" ? Number(edited.quantity) : 0,
  //           beginningInventory:
  //             adjustmentType === "Beginning Inventory"
  //               ? Number(edited.quantity)
  //               : 0,
  //           actualAdjustments:
  //             adjustmentType === "Actual Count" ? Number(edited.quantity) : 0,
  //         },

  //         // Physical count if applicable
  //         physicalCount:
  //           adjustmentType === "Actual Count"
  //             ? String(edited.quantity)
  //             : undefined,
  //         lastActualCountAt:
  //           adjustmentType === "Actual Count" ? now : undefined,

  //         // Leave salesCount/ideal/costOfGoods/variant to the nightly job
  //       }); // merge/upsert behavior in your adapter
  //     }
  //     this.view.hideProgressDialog();
  //     this.view.navigateBack();
  //   } catch (error) {
  //     console.error("Save error:", error);
  //   }
  // }

  async save() {
    this.view.showProgressDialog();
    const collection = this.view.getCollectionName();
    const user = this.view.getCurrentUser();
    const adjustmentType = this.view.getAdjustmentType();
    const now = new Date().toISOString();

    const editedItems = this.view.state.selectedQuantities || {};
    const infiniteItems = this.view.state.infiniteItems || [];

    // helpers
    const day = new Date().toISOString().slice(0, 10); // 'YYYY-MM-DD'
    const storeId = user?.storeAnalytic?.[0]?.id;
    const storeCode = user?.storeAnalytic?.[0]?.code;

    // Will hold final counts for items that were edited (so we can reuse in pass #2)
    // Map<itemIdOrName, { systemCount, actualCount?, itemId, itemName, uomName }>
    const editedFinals = new Map();

    try {
      // ---------------------------
      // PASS #1: apply edits to inventory, write logs/audit; collect final counts
      // ---------------------------
      for (const id in editedItems) {
        const edited = editedItems[id];
        const found = infiniteItems.find((item) => item.id === id);
        const quantity = parseFloat(edited.quantity || "0");
        const itemName = edited.itemName || found?.itemName;
        const cost = edited.cost || found?.itemName;

        console.log("cost", cost);

        // 1) Fetch the inventory record of this item for this store
        const [existing] = await findObjectUseCase().execute("inventory", {
          where: {
            itemName: { $eq: itemName },
            "storeId.id": { $eq: storeId },
          },
          limit: 1,
        });

        const currentCount = parseFloat(existing?.systemCount || "0");
        let systemCount = quantity;
        let actualCount = null;

        // 2) Adjustment logic
        switch (adjustmentType) {
          case "Manual Add":
            systemCount = currentCount + quantity;
            break;
          case "Manual Deduct":
            systemCount = currentCount - quantity;
            break;
          case "Actual Count":
            actualCount = quantity;
            // Keep systemCount as-is for system stock; many teams do NOT overwrite system with actual here.
            // If you want to also set systemCount = actualCount, uncomment the next line:
            // systemCount = quantity;
            break;
          case "Beginning Inventory":
          default:
            systemCount = quantity;
            break;
        }

        // 3) Upsert inventory
        const payload = {
          id: existing?.id,
          sku: edited?.sku || existing?.sku,
          itemName: edited.itemName || existing?.itemName || itemName,
          cost: edited.cost || existing?.itemName || cost,
          systemCount: systemCount.toString(),
          actualCount:
            adjustmentType === "Actual Count" ? quantity.toString() : undefined,
          uom: found?.uom || existing?.uom || {},
          lastAdjusted: now,
          adjustedBy: { id: user.id },
          // adjustmentType, // if you want to store it on the inventory object, uncomment
          acl: this.view.getAcl(),
          storeId: { id: storeId },
        };

        const result = await this.upsertUseCase.execute(collection, payload);

        // 4) Log & audit
        const logEntry = {
          user: { id: user.id },
          itemName: payload.itemName,
          adjustmentType,
          oldQuantity: currentCount.toString(),
          newQuantity: systemCount.toString(),
          storeId: { id: storeId },
        };
        await this.upsertUseCase.execute("inventory_logs", logEntry);

        await auditLogUseCase().create({
          user: { id: user.id },
          logDate: new Date().toISOString(),
          message: `${adjustmentType}: ${
            result.itemName
          } from ${currentCount.toString()} to ${systemCount.toString()}`,
          collection,
          objectId: result.id,
          payload: {
            before: existing || null,
            after: result,
          },
          store: { id: storeId },
        });

        // Save final counts for this edited item (for the pass #2)
        editedFinals.set(
          // Prefer the inventory document id; fallback to itemName to keep the key stable
          result.id || existing?.id || itemName,
          {
            systemCount,
            actualCount:
              adjustmentType === "Actual Count" ? quantity : undefined,
            itemId: result.id || existing?.id || itemName,
            itemName: result.itemName || itemName,
            uomName:
              found?.uom?.name || found?.uom || existing?.uom?.name || "",
          }
        );
      }

      // ---------------------------
      // PASS #2: upsert fc_variant for ALL inventory items in the store
      // ---------------------------
      // Fetch all inventory rows for the store. Increase limit as needed or paginate.
      const allInventory = await findObjectUseCase().execute("inventory", {
        where: { "storeId.id": { $eq: storeId } },
        limit: 10000,
      });

      // Upsert all fc_variant rows for the current day
      const variantUpserts = allInventory.map(async (inv) => {
        const invId = inv?.id || inv?.itemName; // stable key if id is missing
        const final = editedFinals.get(invId);
        console.log("final", final);

        // Use the edited systemCount if present; else the current inventory systemCount
        const systemCount = final
          ? final.systemCount
          : parseFloat(inv?.systemCount || "0");

        const pCount =
          final && typeof final.actualCount === "number"
            ? String(final.actualCount)
            : undefined;
        console.log("System Count:", systemCount);
        console.log("pcount", pCount);
        console.log("cosy", inv?.cost);
        const idealNum = Number(systemCount) - Number(pCount);
        const variantNum = Number(idealNum) - Number(inv?.saleCount || 10);
        const costofGoodsNum = Number(inv?.cost) * Number(inv?.saleCount || 10);

        const uomName = final?.uomName || inv?.uom?.name || inv?.uom || ""; // best-effort

        const key = `${storeId}|${invId}|${day}`;
        console.log("pCount", inv?.actualCount);
        console.log("systemCount", systemCount);

        const salesCountDay =
          Number(inv?.actualCount || 0) - Number(systemCount);

        console.log("salesCountDay", salesCountDay);

        return this.upsertUseCase.execute("fc_variant", {
          variantId: key, // map to _id server-side if needed
          storeId: { id: storeId, code: storeCode },
          item: {
            id: invId,
            name: final?.itemName || inv?.itemName,
            uom: uomName,
          },
          variantDate: day,
          fcProduct: final?.itemName || inv?.itemName,
          beginningInventory: String(systemCount),
          salesCount: String(inv?.saleCount || 10), // this is the used item
          ending: String(systemCount), // align with inventory.systemCount snapshot
          pCount, // physical count if Actual Count happened
          costOfGoods: String(costofGoodsNum), // nightly job
          ideal: String(idealNum), // nightly job
          variant: String(variantNum), // nightly job
          movements: {
            manualAdd: 0,
            manualDeduct: 0,
            beginningInventory: 0,
            actualAdjustments: 0,
            // If you want to reflect movements for edited items, you can read adjustmentType here,
            // but since pass #2 handles ALL items, we keep movements zeroed to treat this as a daily snapshot.
          },
          physicalCount: pCount,
          lastActualCountAt: pCount ? now : undefined,
        });
      });

      await Promise.all(variantUpserts);

      this.view.hideProgressDialog();
      this.view.navigateBack();
    } catch (error) {
      console.error("Save error:", error);
      this.view.hideProgressDialog();
      // optionally show a toast/dialog
    }
  }

  async submit() {
    try {
      this.view.submitting();
      dialog.close();
      await this.save();

      dialog.fire({
        html: (
          <DialogModal
            icon="bi bi-question-octagon-fill"
            iconColor="#82c14a"
            title="Saved Successfully"
            message=""
            isCancelButton={false}
            onSubmit={() => {
              dialog.close();
            }}
            onClose={() => dialog.close()}
          />
        ),
        footer: false,
      });
    } catch (error) {
      this.view.submissionError(error);
      this.view.showError(error);
    }
  }
}

export default InventoryFormPresenter;
